import client from "./client";

export default {
    async getBusinessInvoicesSummary(filters) {
        return client.parseResponse(await client.get('/business-invoices/summary', filters));
    },

    async previewBusinessInvoiceGeneration(filters) {
        return client.parseResponse(await client.get('/business-invoices/preview-generation', filters));
    },

    async getBusinessInvoices(filters) {
        return client.parseResponse(await client.get('/business-invoices', filters));
    },

    async getBusinessInvoice(id) {
        return client.parseResponse(await client.get(`/business-invoices/${id}`));
    },

    async recordBusinessInvoicePayment(id, data) {
        return client.parseResponse(await client.post(`/business-invoices/${id}/record-payment`, data));
    },

    async updateBusinessFeeRate(businessId, data) {
        return client.parseResponse(await client.post(`/business-invoices/business/${businessId}/fee-rate`, data));
    },

    async disableBusiness(businessId, data) {
        return client.parseResponse(await client.post(`/business-invoices/business/${businessId}/disable`, data));
    },

    async enableBusiness(businessId) {
        return client.parseResponse(await client.post(`/business-invoices/business/${businessId}/enable`));
    },

    // Unauthenticated on purpose - see PaymentController@unlockAccountInfo / @payUnlockInvoice.
    async getUnlockInfo(token) {
        return client.parseResponse(await client.get(`/business-invoice/unlock/${token}`));
    },

    async payUnlockInvoice(data) {
        return client.parseResponse(await client.post('/business-invoice/unlock/pay', data));
    },

    // Authenticated self-service versions (PaymentController@myBusinessInvoices /
    // @payBusinessInvoice) - same shape as the unlock-token pair above, for the
    // PM dashboard banner + in-dashboard pay page, used before a business is
    // ever actually blocked.
    async getMyBusinessInvoices() {
        return client.parseResponse(await client.get('/my-business-invoices'));
    },

    async payMyBusinessInvoice(data) {
        return client.parseResponse(await client.post('/pay-business-invoice', data));
    },
}
